(function(){
  "use strict";

  angular.module("modules.priceStartingAt", []);

})();